var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-virtual-scroll',{attrs:{"items":_vm.allSpecies,"item-height":30,"bench":"10","height":"calc(100% - 48px)"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('v-list-item',{attrs:{"to":_vm.speciesUrl(item)}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(item.name))])],1),_c('v-list-item-action',[_vm._v(" "+_vm._s(item.tone)+" ")])],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }